export default __webpack_public_path__ + "static/media/big_avatar.c66cc9ee.svg";